import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

export default function BrandBox() {
  return (
    <div className="navbar-brand NavBar__brandContainer NavBar__brandContainer--box">
      <div className="NavBar__brandAssociationLarge">
        <Link to="/">
          <img src="https://cdn.fanatical.com/production/brand/co-brands/box-logo-black.svg" alt="Box" className="NavBar__brandAssociationLarge__image" />
        </Link>
      </div>
      <div className="NavBar__brandLogoSupport">
        <div className="NavBar__brandSupportText">
          <FormattedMessage id="brand-box.curated-for" defaultMessage="Curated by" />
        </div>
        <Link to="/" className="NavBar__brandLogo">
          <img src="https://cdn.fanatical.com/production/brand/fanatical-logo-black.svg" alt="Fanatical" />
        </Link>
      </div>
    </div>
  );
}
